import gql from 'graphql-tag';

export default gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
        resetPassword(input: $input) {
            clientMutationId
        }
    }
`;